var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-bookmark__slide__panel", style: _vm.style },
    [
      _c(
        "ul",
        { staticClass: "my-bookmark__tag-list" },
        [
          _vm._l(_vm.tagList, function (tag) {
            return _c("tag-item", {
              attrs: { tag: tag, focused: _vm.focused },
              on: { "tag-select": _vm.onTagSelect },
            })
          }),
          _vm._v(" "),
          _vm.page + 1 === _vm.maxPage && _vm.page % 2 ? _c("li") : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }